import { ApiError, BaseResponseType, apiClient } from 'shared/api';

export const postGuideEmailRecipients = async (request: { email: string }): Promise<BaseResponseType<string>> => {
  const { data } = await apiClient.post(`/marketing/guide-email-recipients`, request);

  if (!data.isSuccess) {
    throw new ApiError(data);
  }

  return data;
};
